module.exports = __webpack_public_path__ + "media/images/tasks_empty-state-dcc68ed8.svg";